import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { PipesModule } from './core/pipes/pipes.module';
import { AutenticarComponent } from './security/autenticar/autenticar.component';
import { ApiService } from './services/api.service';
import { SharedModule } from './shared/shared.module';
import { LazyLoadImageModule , LAZYLOAD_IMAGE_HOOKS , ScrollHooks } from 'ng-lazyload-image';


export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        AutenticarComponent
    ],
    imports: [
        BrowserModule,
        LazyLoadImageModule,
        RouterModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ToastrModule.forRoot({
            preventDuplicates: true
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        NgCircleProgressModule.forRoot({}),

        // App Modules
        SharedModule,            
        CoreModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.enableProdMode,
        }),
        PipesModule,
    ],
    providers: [
        ApiService,
        { provide : LAZYLOAD_IMAGE_HOOKS ,  useClass :  ScrollHooks }
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
